import React from 'react';

const License: React.FC = () => {
  return (
    <div className="license">
      <h1>Lizenz</h1>
      <p>Ihre aktuellen Lizenzinformationen und Status.</p>
    </div>
  );
};

export default License;
